<template>
    <section class="city-map-legend__block">
        <div class="city-map-legend__title" :class="mapLayout">
            <span v-html="titleDecoded"></span>
        </div>
        <div class="city-map-legend__separator">
            <div class="coords-label">
                <div class="coords-text">
                    <div class="coords-line"></div>
                    {{coordsLabel}}
                </div>
            </div>
        </div>
        <div class="city-map-legend__subtitle" v-html="subTitleDecoded"></div>
    </section>
</template>

<script>
    import CityMapModule from "../store-mixin";

    export default {
        name: 'CityMapTitle',
        mixins: [CityMapModule()],
        watch: {
            city: {
                handler: function (newValue, oldValue) {
                    this.titleDecoded = this.$twemoji.parse(newValue)
                },
                immediate: true
            },
            country: {
                handler: function (newValue, oldValue) {
                    this.subTitleDecoded = this.$twemoji.parse(newValue)
                },
                immediate: true
            },
        },
        data() {
            return {
                titleDecoded: null,
                subTitleDecoded: null,
            }
        },
        computed: {
            coordsLabel() {
                let [lat, lng] = this.center
                return `${Number(lat).toFixed(3)}° N / ${Number(lng).toFixed(3)}° E`
            },
        }
    }
</script>

<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700&display=swap');

    .city-map-legend {


        &__block {
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 15%, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 1) 100%);
            text-align: center;
            padding-top: 50px;
            position: absolute;
            bottom: -5px;
            left: -2px;
            right: -2px;
            /*position: relative;*/
            z-index: 999;
            /*box-shadow: 0 -2px 6px 0px #DDDDDD;*/
            ::v-deep .emoji {
                height: 40px !important;
                width: 40px !important;
                vertical-align: middle !important;
            }
        }

        &__title {
            color: #292929;
            text-transform: uppercase;
            font-weight: bold;
            font-family: 'Montserrat', sans-serif;
            letter-spacing: 16px;
            margin-bottom: -5px;
            font-size: 82px;

            &.vertical {

            }

            &.horizontal {

            }


            &--img {
                height: 40px;
                width: 40px;
                vertical-align: middle !important;
            }
        }

        &__subtitle {
            font-family: 'Montserrat', sans-serif;
            font-size: 44px;
            color: #292929;
            text-transform: uppercase;
            margin-top: 7px;
            line-height: 60px;
            letter-spacing: -1px;

            .city-name {
                text-transform: uppercase;
            }
        }

        &__separator {
            position: relative;
            padding: 0;


            .coords-label {
                position: relative;
                display: inline-block;

                .coords-text {
                    font-family: 'Montserrat', sans-serif;
                    font-size: 24px;
                    display: inline-block;
                    z-index: 1;
                    background: white;
                    padding: 5px 30px;
                }

                .coords-line {
                    content: ' ';
                    display: block;
                    border-top: 3px solid #292929;
                    width: 120%;
                    left: -10%;
                    position: absolute;
                    top: calc(50% - 2px);
                    z-index: -1;
                }
            }
        }
    }

</style>

